import React, { useState, useEffect } from 'react';

import styles from './CommunityMaster.module.css';
import { REACT_APP_API_BASE_URL } from '../../apiurl';
import api from '../../services/api';

const EditIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
);

const TrashIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4h6v2" />
    </svg>
);

const CommunityMaster = () => {
    const [expandedSequenceId, setExpandedSequenceId] = useState(null); // Track which row is expanded
    const [searchQuery, setSearchQuery] = useState('');
    const [modalType, setModalType] = useState('sequence'); // 'sequence' | 'post'
    const [sequences, setSequences] = useState([]);
    const [scanResults, setScanResults] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isAddingPostTo, setIsAddingPostTo] = useState(null);// Track seq.id for inline add
    const [editingPostId, setEditingPostId] = useState(null);
    const [expandedPostContentIds, setExpandedPostContentIds] = useState([]);
    const [saveFeedback, setSaveFeedback] = useState(null);
    const [postPages, setPostPages] = useState({});
    const POSTS_PER_PAGE = 10;
    const [activeTab, setActiveTab] = useState('scans'); // 'scans' | 'scan_log'
    const [scanLogs, setScanLogs] = useState([]);
    const [scanLogPage, setScanLogPage] = useState(1);
    const SCAN_LOG_PER_PAGE = 20;

    const [selectedDescription, setSelectedDescription] = useState(null);
    const [selectedQuery, setSelectedQuery] = useState(null);

    // Scan Execution State
    const [scanErrors, setScanErrors] = useState({});
    const [scanLoading, setScanLoading] = useState({});

    const [internalTokens, setInternalTokens] = useState([]);
    const [users, setUsers] = useState([]);



    // Form States
    const [sequenceForm, setSequenceForm] = useState({
        name: '', description: '',
        scan_class: '', scan_type: '',
        scan_direction: '', scan_timeframe: '',
        indicator: '', scan_query: '',
        active_state: '', premium_category: '',
        trigger_time: '',
        display: false
    });
    const [postForm, setPostForm] = useState({
        content_sequence_id: '',
        content: '',
        content_type_id: 1, // Default Sequence
        posting_user_id: Number(localStorage.getItem('userId')) || 1, // Default Admin
        content_script_id: 0,
        content_script_timeframe: '',
        content_description: '',
        content_symbol: '' // Added content_symbol
    });

    const CONTENT_TYPES = [
        { id: 1, name: 'Sequence' },
        { id: 2, name: 'Post' },
        { id: 3, name: 'Text' },
        { id: 4, name: 'News' },
        { id: 5, name: 'Poll' },
        { id: 6, name: 'Image' }
    ];

    const TIMEFRAMES = [
        { id: 0, name: '1m' },
        { id: 1, name: '5m' },
        { id: 2, name: '10m' },
        { id: 3, name: '15m' },
        { id: 4, name: '1h' },
        { id: 5, name: '1 day' },
        { id: 6, name: '1 week' },
        { id: 7, name: '1 month' },
    ];

    // Scan dropdown constants (hardcoded from reference image)
    const SCAN_CLASSES = [
        { id: 1, name: 'Technical' },
        { id: 2, name: 'Fundamental' },
    ];
    const SCAN_TYPES = [
        { id: 1, name: 'Price Scans' },
        { id: 2, name: 'Candle Patterns' },
        { id: 3, name: 'Candlestick Patterns' },
        { id: 4, name: 'Volume Scans' },
    ];
    const SCAN_DIRECTIONS = [
        { id: 1, name: 'Bullish' },
        { id: 2, name: 'Bearish' },
        { id: 3, name: 'Sideways' },
        { id: 4, name: 'Momentum' },
        { id: 5, name: 'Reversal' },
        { id: 6, name: 'Breakouts' },
        { id: 7, name: 'Breakdowns' },
        { id: 8, name: 'Neutral' },
    ];
    const SCAN_TIMEFRAMES = [
        { id: 1, name: 'Minute' },
        { id: 2, name: '5 Minutes' },
        { id: 3, name: '10 Minutes' },
        { id: 4, name: '15 Minutes' },
        { id: 5, name: '30 Minutes' },
        { id: 6, name: '1 Hour' },
        { id: 7, name: '1 Day' },
        { id: 8, name: '1 Week' },
    ];
    const INDICATORS = [
        { id: 3, name: 'RSI' },
        { id: 4, name: 'MACD' },
        { id: 5, name: 'SMA' },
    ];
    const ACTIVE_STATES = [
        { value: 'true', label: 'Active (True)' },
        { value: 'false', label: 'Inactive (False)' },
    ];
    const PREMIUM_CATEGORIES = [
        { value: '1', label: 'True' },
        { value: '2', label: 'False' },
    ];
    const Display= [
         { value: true, label: 'True' },
        { value: false, label: 'False' },
    ]

    const API_URL = REACT_APP_API_BASE_URL; // Or from env

    useEffect(() => {
        fetchSequences();
        fetchInternalTokens();
        fetchUsers();
        fetchScanResults();
        fetchScanLogs();
    }, []);

    const fetchUsers = async () => {
        try {
            const res = await api.get(`/users?limit=1000`); // Fetch enough users
            const data = await res.data;
            if (data) setUsers(data);
        } catch (err) {
            console.error("Failed to fetch users", err);
        }
    };

    const fetchInternalTokens = async () => {
        try {
            const res = await api.get(`/internaltoken/list`);
            const data = await res.data;
            if (data.status && data) setInternalTokens(data);
        } catch (err) {
            console.error("Failed to fetch tokens", err);
        }
    };

    const fetchSequences = async () => {
        try {
            const res = await api.get(`/communitysequence/community-sequences`);
            const data = await res.data;
            if (data) setSequences(data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchScanLogs = async () => {
        try {
            const res = await api.get(`/communitysequence/scan-logs`);
            if (res.data && res.data.data) setScanLogs(res.data.data);
        } catch (err) {
            console.error('Failed to fetch scan logs', err);
        }
    };

    const fetchScanResults = async () => {
        try {
            const res = await api.get(`/communitysequence/scan-results`);
            if (res.data) {
                setScanResults([...res.data]); // Use spread to force reference change
            }
        } catch (err) {
            console.error('Failed to fetch scan results', err);
        }
    };

    const handleRunScanQuery = async (seq) => {
        if (!seq.scan_query) return;
        try {
            setScanLoading(prev => ({ ...prev, [seq.id]: true }));
            setScanErrors(prev => ({ ...prev, [seq.id]: null }));
            const res = await api.post(`/communitysequence/community-sequences/execute-scan`, { scan_query: seq.scan_query, sequence_id: seq.id });

            if (res && res.status) {
                if (res.insertedCount === 0) {
                    setScanErrors(prev => ({ ...prev, [seq.id]: "Query returned 0 results." }));
                } else {
                    setSaveFeedback({ id: seq.id, message: `Synced ${res.insertedCount} posts successfully!` });
                    setTimeout(() => setSaveFeedback(null), 3000);
                    await fetchScanResults();
                }
            } else {
                setScanErrors(prev => ({ ...prev, [seq.id]: res?.message || "Failed to execute query." }));
            }
        } catch (err) {
            console.error("Scan Execution Data Error:", err);
            setScanErrors(prev => ({ ...prev, [seq.id]: err?.message || err.message || "Failed to execute scan query" }));
        } finally {
            setScanLoading(prev => ({ ...prev, [seq.id]: false }));
        }
    };

    const handleSaveSequence = async (e) => {
        e.preventDefault();
        try {
            const isEdit = modalType === 'edit_sequence';
            const url = isEdit
                ? `${API_URL}api/communitysequence/community-sequences/${sequenceForm.id}`
                : `${API_URL}api/communitysequence/community-sequences`;

            const method = isEdit ? 'PUT' : 'POST';

            const res = await fetch(url, {
                method: method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: sequenceForm.id,
                    user_id: 1, // Admin
                    sequence_name: sequenceForm.name,
                    sequence_description: sequenceForm.description,
                    scan_class: sequenceForm.scan_class || null,
                    scan_type: sequenceForm.scan_type || null,
                    scan_direction: sequenceForm.scan_direction || null,
                    scan_timeframe: sequenceForm.scan_timeframe || null,
                    scan_query: sequenceForm.scan_query || null,
                    indicator: sequenceForm.indicator || null,
                    premium_category: sequenceForm.premium_category || null,
                    active_state: sequenceForm.active_state !== '' ? sequenceForm.active_state === 'true' : null,
                    display: !!sequenceForm.display,
                    trigger_time: sequenceForm.trigger_time || null,
                })
            });
            const data = await res.json();
            if (data.status) {
                alert(isEdit ? 'Scan Updated!' : 'Scan Created!');
                setShowModal(false);
                fetchSequences();
                setSequenceForm({ name: '', description: '', scan_class: '', scan_type: '', scan_direction: '', scan_timeframe: '', indicator: '', scan_query: '', active_state: '', premium_category: '', trigger_time: '', display: false });
            } else {
                alert('Error: ' + data.message);
            }
        } catch (err) {
            alert('Failed to save scan');
        }
    };

    const handleDeleteSequence = async (id) => {
        if (!window.confirm('Are you sure? This will delete the sequence and ALL its posts!')) return;
        try {
            const res = await fetch(`${API_URL}api/communitysequence/community-sequences/${id}`, {
                method: 'DELETE'
            });
            const data = await res.json();
            if (data.status) {
                alert('Sequence Deleted!');
                fetchSequences();
            } else {
                alert('Error deleting sequence: ' + data.message);
            }
        } catch (err) {
            console.error(err);
            alert('Failed to delete sequence');
        }
    };

    const handleEditSequenceClick = (seq) => {
        setSequenceForm({
            id: seq.id,
            name: seq.sequence_name,
            description: seq.sequence_description,
            scan_class: seq.scan_class || '',
            scan_type: seq.scan_type || '',
            scan_direction: seq.scan_direction || '',
            scan_timeframe: seq.scan_timeframe || '',
            indicator: seq.indicator || '',
            scan_query: seq.scan_query || '',
            active_state: seq.active_state != null ? String(seq.active_state) : '',
            premium_category: seq.premium_category || '',
            trigger_time: seq.trigger_time || '',
            display: !!seq.display,
        });
        setModalType('edit_sequence');
        setShowModal(true);
    };

    const handleCreatePost = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                ...postForm,
                content_sequence_id: postForm.content_sequence_id || null,
                content_script_id: postForm.content_script_id || null,
                content_script_timeframe: postForm.content_script_timeframe || '1m',
                content_symbol: postForm.content_symbol || null // Ensure symbol is sent
            };

            let url = `${API_URL}api/communitypost`;
            let method = 'POST';

            if (editingPostId) {
                url = `${API_URL}api/communitypost/${editingPostId}`;
                method = 'PUT';
            }

            const res = await fetch(url, {
                method: method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data.status) {
                setIsAddingPostTo(null);
                setEditingPostId(null);
                fetchScanResults();
                resetPostForm();

                // Set feedback
                const feedbackId = editingPostId || 'new';
                setSaveFeedback({ id: feedbackId, message: editingPostId ? 'Updated!' : 'Created!' });
                setTimeout(() => setSaveFeedback(null), 3000);
            } else {
                console.error("Save Post Error:", data);
                alert(`Error: ${data.message || 'Unknown error'} (Status: ${data.status})`);
            }
        } catch (err) {
            console.error("Network/Server Error:", err);
            alert('Failed to save post. Check console for details.');
        }
    };

    const handleDeletePost = async (id) => {
        // if (!window.confirm('Are you sure you want to delete this post?')) return; // Removed confirmation for posts
        try {
            const res = await fetch(`${API_URL}api/communitypost/${id}`, {
                method: 'DELETE'
            });
            const data = await res.json();
            if (data.status) {
                fetchScanResults();
            } else {
                alert('Error deleting post: ' + data.message);
            }
        } catch (err) {
            console.error(err);
            alert('Failed to delete post');
        }
    };

    const handleEditClick = (post) => {
        setPostForm({
            content_id: post.content_id,
            content_sequence_id: post.content_sequence_id,
            content: post.content,
            content_type_id: post.content_type_id,
            posting_user_id: post.posting_user_id,
            content_script_id: post.content_script_id || 0,
            content_script_timeframe: post.content_script_timeframe || '',
            content_symbol: post.content_symbol || '' // Populate symbol
        });
        setEditingPostId(post.content_id);
    };

    const resetPostForm = () => {
        setPostForm({
            content_sequence_id: '',
            content: '',
            content_type_id: 1,
            posting_user_id: Number(localStorage.getItem('userId')) || 1,
            content_script_id: 0,
            content_script_timeframe: '1m',
            content_symbol: ''
        });
        setIsAddingPostTo(null);
        setEditingPostId(null);
    };

    // Filter sequences based on search
    const filteredSequences = sequences.filter(seq =>
        seq.sequence_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (seq.sequence_description && seq.sequence_description.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const toggleExpand = (id) => {
        setExpandedSequenceId(expandedSequenceId === id ? null : id);
    };

    const togglePostContent = (postId) => {
        setExpandedPostContentIds(prev =>
            prev.includes(postId)
                ? prev.filter(id => id !== postId)
                : [...prev, postId]
        );
    };

    const MAX_POST_LENGTH = 10;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <h2>Scans Master</h2>
                    <p>Manage community scans and sequences</p>
                </div>

                <div className={styles.headerRight}>
                    <div className={styles.searchBox}>
                        <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                        <input
                            type="text"
                            placeholder="Search scans..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className={styles.searchInput}
                        />
                    </div>
                    <button className={styles.addButton} onClick={() => { setSequenceForm({ name: '', description: '', scan_class: '', scan_type: '', scan_direction: '', scan_timeframe: '', scan_query: '', image: null, trigger_time: '', display: false }); setModalType('sequence'); setShowModal(true); }}>
                        + Add New Scan
                    </button>
                </div>
            </div>

            {/* ERROR / SUCCESS Message Display could go here */}

            {/* Tab Bar — commented out until Scan Log UI is ready
            <div className={styles.tabContainer}>
                <button onClick={() => setActiveTab('scans')} className={`${styles.tabBtn} ${activeTab === 'scans' ? styles.active : styles.inactive}`}>📋 Scans</button>
                <button onClick={() => { setActiveTab('scan_log'); fetchScanLogs(); }} className={`${styles.tabBtn} ${activeTab === 'scan_log' ? styles.active : styles.inactive}`}>📜 Scan Log</button>
            </div>
            */}

            {/* Scan Log Table — commented out until DB migration is run
            {activeTab === 'scan_log' ? (
                <div className={styles.content}>
                    ... scan log table ...
                </div>
            ) : null}
            */}

            <div className={styles.content}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Class</th>
                            <th>Type</th>
                            <th>Direction</th>
                            <th>Timeframe</th>
                            <th>Indicator</th>
                            <th>Trigger Time</th>
                            <th>Display</th>
                            <th>Active</th>
                            <th>Premium</th>
                            <th>Query</th>
                            <th>Created</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredSequences.map(seq => (
                            <React.Fragment key={seq.id}>
                                <tr className={expandedSequenceId === seq.id ? styles.expandedRow : ''}>
                                    <td>
                                        <button
                                            className={styles.expandBtn}
                                            onClick={() => toggleExpand(seq.id)}
                                        >
                                            {expandedSequenceId === seq.id ? '➖' : '➕'}
                                        </button>
                                    </td>
                                    <td>{seq.id}</td>
                                    <td>{seq.sequence_name}</td>
                                    <td className={styles.colMax150} title={seq.sequence_description || ''}>
                                        <div className={styles.flexBetween}>
                                            <span className={styles.textTruncate}>
                                                {seq.sequence_description ? seq.sequence_description.substring(0, 25) + (seq.sequence_description.length > 25 ? '...' : '') : '-'}
                                            </span>
                                            {seq.sequence_description && seq.sequence_description.length > 25 && (
                                                <button className={styles.linkBtn} onClick={() => setSelectedDescription(seq.sequence_description)} >
                                                    See more
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                    <td>{seq.scan_class || '-'}</td>
                                    <td>{seq.scan_type || '-'}</td>
                                    <td>{seq.scan_direction || '-'}</td>
                                    <td>{seq.scan_timeframe || '-'}</td>
                                    <td>{seq.indicator || '-'}</td>
                                    <td>{seq.trigger_time || '-'}</td>
                                    <td>
                                        <span className={`${styles.badge} ${seq.display === true ? styles.success : styles.error}`}>
                                            {seq.display === true ? 'Yes' : 'No'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`${styles.badge} ${seq.active_state === true ? styles.success : styles.error}`}>
                                            {seq.active_state === true ? 'Active' : seq.active_state === false ? 'Inactive' : '-'}
                                        </span>
                                    </td>
                                    <td>{seq.premium_category || '-'}</td>
                                    <td>
                                        {seq.scan_query ? (
                                            <button className={styles.actionBtn} onClick={() => setSelectedQuery(seq.scan_query)} >
                                                View
                                            </button>
                                        ) : '-'}
                                    </td>
                                    <td>{seq.created_at && !isNaN(new Date(seq.created_at).getTime()) ? new Date(seq.created_at).toLocaleDateString() : '-'}</td>
                                    <td>
                                        <div className={styles.flexGap8}>
                                            <button className={styles.iconBtn} onClick={() => handleEditSequenceClick(seq)} title="Edit Scan">
                                                <EditIcon />
                                            </button>
                                            <button className={`${styles.iconBtn} ${styles.deleteBtn}`} onClick={() => handleDeleteSequence(seq.id)} title="Delete Scan">
                                                <TrashIcon />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                {expandedSequenceId === seq.id && (
                                    <tr>
                                        <td colSpan="14" className={styles.nestedCell}>
                                            <div className={styles.nestedContainer}>
                                                <div className={styles.nestedHeader}>
                                                    <h4>scans results for {seq.sequence_name}</h4>
                                                    <div className={styles.flexCenterGap10}>
                                                        {saveFeedback?.id === 'new' && <span className={styles.feedbackMessage}>{saveFeedback.message}</span>}
                                                        {seq.scan_query && (
                                                            <button
                                                                className={`${styles.primaryBtn} ${styles.smallBtn}`}
                                                                onClick={() => handleRunScanQuery(seq)}
                                                                disabled={scanLoading[seq.id]}
                                                            >
                                                                {scanLoading[seq.id] ? "Loading..." : "Run Query"}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>

                                                <table className={styles.nestedTable}>
                                                    <thead>
                                                        <tr>
                                                            <th>Scan ID</th>
                                                            <th>Scan Name</th>
                                                            <th>Token</th>
                                                            <th>Symbol</th>
                                                            <th>Timestamp</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {scanLoading[seq.id] ? (
                                                            <tr>
                                                                <td colSpan="5" className={styles.emptyStateCell}>Generating results from scan query...</td>
                                                            </tr>
                                                        ) : (
                                                            <>
                                                                {(() => {
                                                                    const seqResults = scanResults.filter(r => {
                                                                        const isMatch = Number(r.scan_id) === Number(seq.id);
                                                                        if (expandedSequenceId === seq.id) {
                                                                            console.log(`Checking match: result.scan_id(${r.scan_id}) === seq.id(${seq.id}) -> ${isMatch}`);
                                                                        }
                                                                        return isMatch;
                                                                    });
                                                                    const currentPage = postPages[seq.id] || 1;
                                                                    const paginated = seqResults.slice((currentPage - 1) * POSTS_PER_PAGE, currentPage * POSTS_PER_PAGE);

                                                                    return (
                                                                        <>
                                                                            {seqResults.length > 0 ? (
                                                                                paginated.map(result => (
                                                                                    <tr key={result.id}>
                                                                                        <td>{result.scan_id}</td>
                                                                                        <td>{result.scan_name}</td>
                                                                                        <td>{result.token}</td>
                                                                                        <td>{result.symbol}</td>
                                                                                        <td>{result.scan_timestamp ? new Date(result.scan_timestamp).toLocaleString() : '-'}</td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="5" className={styles.emptyStateCell}>No scan results found. Run query to generate!</td>
                                                                                </tr>
                                                                            )}
                                                                        </>
                                                                    );
                                                                })()}
                                                            </>
                                                        )}
                                                    </tbody>
                                                </table>

                                                {/* Pagination Controls */}
                                                {(() => {
                                                    const seqResults = scanResults.filter(r => Number(r.scan_id) === Number(seq.id));
                                                    const currentPage = postPages[seq.id] || 1;
                                                    const totalPages = Math.ceil(seqResults.length / POSTS_PER_PAGE);
                                                    if (totalPages <= 1) return null;
                                                    return (
                                                        <div className={styles.paginationContainer}>
                                                            <button className={`${styles.primaryBtn} ${styles.smallBtn}`} disabled={currentPage === 1} onClick={() => setPostPages(prev => ({ ...prev, [seq.id]: currentPage - 1 }))}>← Prev</button>
                                                            <span className={styles.paginationText}>Page {currentPage} of {totalPages} &nbsp;({seqResults.length} results)</span>
                                                            <button className={`${styles.primaryBtn} ${styles.smallBtn}`} disabled={currentPage === totalPages} onClick={() => setPostPages(prev => ({ ...prev, [seq.id]: currentPage + 1 }))}>Next →</button>
                                                        </div>
                                                    );
                                                })()}

                                                {/* Error State */}
                                                {scanErrors[seq.id] && (
                                                    <div className={styles.errorMessage}>
                                                        Error: {scanErrors[seq.id]}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modal}>
                        <div className={styles.modalHeader}>
                            <h3>
                                {modalType === 'sequence'
                                    ? 'Add New Scan'
                                    : modalType === 'edit_post'
                                        ? 'Edit Post'
                                        : modalType === 'edit_sequence'
                                            ? 'Edit Scan'
                                            : `Add Post to ${sequences.find(s => s.id === postForm.content_sequence_id)?.sequence_name || 'Scan'}`
                                }
                            </h3>
                            <button className={styles.closeBtn} onClick={() => setShowModal(false)}>×</button>
                        </div>

                        {modalType === 'sequence' || modalType === 'edit_sequence' ? (
                            <form onSubmit={handleSaveSequence}>
                                <div className={styles.modalBody}>
                                    {/* Row 1: Name + Description side by side */}
                                    <div className={styles.grid2Cols}>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Scan Name *</label>
                                            <input type="text" value={sequenceForm.name} onChange={e => setSequenceForm({ ...sequenceForm, name: e.target.value })} required />
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Scan Class</label>
                                            <select value={sequenceForm.scan_class} onChange={e => setSequenceForm({ ...sequenceForm, scan_class: e.target.value })}>
                                                <option value="">-- Select --</option>
                                                {SCAN_CLASSES.map(o => <option key={o.id} value={o.name}>{o.name}</option>)}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Row 2: All dropdowns auto-fill, wraps on small screens */}
                                    <div className={styles.gridAutoCols}>
                                        <div className={styles.formGroup}>
                                            <label>Scan Type</label>
                                            <select value={sequenceForm.scan_type} onChange={e => setSequenceForm({ ...sequenceForm, scan_type: e.target.value })}>
                                                <option value="">-- Select --</option>
                                                {SCAN_TYPES.map(o => <option key={o.id} value={o.name}>{o.name}</option>)}
                                            </select>
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Scan Direction</label>
                                            <select value={sequenceForm.scan_direction} onChange={e => setSequenceForm({ ...sequenceForm, scan_direction: e.target.value })}>
                                                <option value="">-- Select --</option>
                                                {SCAN_DIRECTIONS.map(o => <option key={o.id} value={o.name}>{o.name}</option>)}
                                            </select>
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Scan Timeframe</label>
                                            <select value={sequenceForm.scan_timeframe} onChange={e => setSequenceForm({ ...sequenceForm, scan_timeframe: e.target.value })}>
                                                <option value="">-- Select --</option>
                                                {SCAN_TIMEFRAMES.map(o => <option key={o.id} value={o.name}>{o.name}</option>)}
                                            </select>
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Indicator</label>
                                            <select value={sequenceForm.indicator} onChange={e => setSequenceForm({ ...sequenceForm, indicator: e.target.value })}>
                                                <option value="">-- Select --</option>
                                                {INDICATORS.map(o => <option key={o.id} value={o.name}>{o.name}</option>)}
                                            </select>
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Active State</label>
                                            <select value={sequenceForm.active_state} onChange={e => setSequenceForm({ ...sequenceForm, active_state: e.target.value })}>
                                                <option value="">-- Select --</option>
                                                {ACTIVE_STATES.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                            </select>
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Premium Category</label>
                                            <select value={sequenceForm.premium_category} onChange={e => setSequenceForm({ ...sequenceForm, premium_category: e.target.value })}>
                                                <option value="">-- Select --</option>
                                                {PREMIUM_CATEGORIES.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                            </select>
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Display</label>
                                            <select value={String(sequenceForm.display)} onChange={e => setSequenceForm({ ...sequenceForm, display: e.target.value === 'true' })}>
                                                <option value="">-- Select --</option>
                                                {Display.map(o => <option key={String(o.value)} value={String(o.value)}>{o.label}</option>)}
                                            </select>
                                        </div>
                                        <div className={`${styles.formGroup} ${styles.m0}`}>
                                            <label>Trigger Time</label>
                                            <input type="time" value={sequenceForm.trigger_time} onChange={e => setSequenceForm({ ...sequenceForm, trigger_time: e.target.value })} />
                                        </div>
                                    </div>

                                    {/* Row 3: Scan Description full width */}
                                    <div className={`${styles.formGroup} ${styles.m0}`}>
                                        <label>Scan Description</label>
                                        <textarea value={sequenceForm.description} onChange={e => setSequenceForm({ ...sequenceForm, description: e.target.value })} />
                                    </div>

                                    {/* Row 4: SQL Query full width */}
                                    <div className={styles.formGroup}>
                                        <label>Scan Query (SQL)</label>
                                        <textarea value={sequenceForm.scan_query} onChange={e => setSequenceForm({ ...sequenceForm, scan_query: e.target.value })} placeholder="Write SQL scan query here..." rows={3} className={styles.queryTextarea} />
                                    </div>
                                </div>

                                <div className={styles.actions}>
                                    <button type="button" className={`${styles.primaryBtn} ${styles.cancelActionBtn}`} onClick={() => setShowModal(false)}>Cancel</button>
                                    <button type="submit" className={styles.primaryBtn}>
                                        {modalType === 'edit_sequence' ? 'Update Scan' : 'Create Scan'}
                                    </button>
                                </div>
                            </form>
                        ) : null}

                    </div>
                </div>
            )}

            {selectedDescription && (
                <div className={styles.modalOverlay} onClick={() => setSelectedDescription(null)}>
                    <div className={`${styles.modal} ${styles.maxWidth500}`} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>Full Description</h3>
                            <button className={styles.closeBtn} onClick={() => setSelectedDescription(null)}>×</button>
                        </div>
                        <div className={styles.modalContentWrap}>
                            {selectedDescription}
                        </div>
                    </div>
                </div>
            )}

            {selectedQuery && (
                <div className={styles.modalOverlay} onClick={() => setSelectedQuery(null)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>Scan Query</h3>
                            <button className={styles.closeBtn} onClick={() => setSelectedQuery(null)}>×</button>
                        </div>
                        <div className={styles.codeBlock}>
                            <code className={styles.displayBlock}>{selectedQuery}</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CommunityMaster;